var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50028 0.5V7C9.50028 7.13261 9.4476 7.25979 9.35383 7.35355C9.26006 7.44732 9.13289 7.5 9.00028 7.5C8.86767 7.5 8.74049 7.44732 8.64672 7.35355C8.55296 7.25979 8.50028 7.13261 8.50028 7V1.70687L1.35403 8.85375C1.26021 8.94757 1.13296 9.00028 1.00028 9.00028C0.867596 9.00028 0.740348 8.94757 0.646528 8.85375C0.552708 8.75993 0.5 8.63268 0.5 8.5C0.5 8.36732 0.552708 8.24007 0.646528 8.14625L7.7934 1H2.50028C2.36767 1 2.24049 0.947321 2.14672 0.853553C2.05296 0.759785 2.00028 0.632608 2.00028 0.5C2.00028 0.367392 2.05296 0.240215 2.14672 0.146447C2.24049 0.0526785 2.36767 0 2.50028 0H9.00028C9.13289 0 9.26006 0.0526785 9.35383 0.146447C9.4476 0.240215 9.50028 0.367392 9.50028 0.5Z",
    fill: "#0763B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewall);
export default __webpack_public_path__ + "static/media/view all.4cb01a2e65fe26c3eb46c900f15bbe21.svg";
export { ForwardRef as ReactComponent };